"use client";
import * as t from "react";
import { u } from "./useEventCallback-CjuAhyNz.mjs";
function a(n) {
  const o = t.useRef(""), r = t.useCallback((e) => {
    e.defaultPrevented || (o.current = e.pointerType, n(e, e.pointerType));
  }, [n]);
  return {
    onClick: t.useCallback((e) => {
      if (e.detail === 0) {
        n(e, "keyboard");
        return;
      }
      "pointerType" in e && n(e, e.pointerType), n(e, o.current), o.current = "";
    }, [n]),
    onPointerDown: r
  };
}
function k(n) {
  const [o, r] = t.useState(null), i = u((p, l) => {
    n || r(l);
  }), e = u(() => {
    r(null);
  }), {
    onClick: c,
    onPointerDown: s
  } = a(i);
  return t.useMemo(() => ({
    openMethod: o,
    reset: e,
    triggerProps: {
      onClick: c,
      onPointerDown: s
    }
  }), [o, e, c, s]);
}
export {
  k as u
};
